import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Card, Form, Input, notification, Select} from 'antd';

import {updateCategory, getCategory, getCategoryTree} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {bindActionCreators} from "redux";
import {getTaxGroups} from "../Tax/actions";
import {formItemLayout} from "../utils/style";
import SelectCategoryTree from "./SelectCategoryTree";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const Option = Select.Option;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class UpdateCategoryForm extends Component {
  static propTypes = {
    form: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    // state
    category: PropTypes.object.isRequired,
    categoryTree: PropTypes.object.isRequired,
    salonId: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    taxGroups: PropTypes.array.isRequired,
    // dispatch
    getCategory: PropTypes.func.isRequired,
    getCategoryTree: PropTypes.func.isRequired,
    getTaxGroups: PropTypes.func.isRequired,
    updateCategory: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.salonId !== prevProps.salonId
      || this.props.match.params.categoryId !== prevProps.match.params.categoryId) {
      this._load();
    }
  }

  _load = () => {
    const {categoryId} = decodeParams(this.props.match.params);
    this.props.getCategory({categoryId});
    const {salonId} = this.props;
    if (salonId) {
      this.props.getCategoryTree({salonId});
      this.props.getTaxGroups({salonId});
    }
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {salonId, match} = this.props;
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        const {categoryId} = decodeParams(match.params);
        await this.props.updateCategory({...values, salonId, categoryId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {category, categoryTree, form: {getFieldDecorator, getFieldsError}, loading, match, taxGroups} = this.props;
    const {categoryId} = decodeParams(match.params);
    const {parentId, name, taxGroupId} = category;
    return (
      <Card title="Updated Category">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Parent"
          >
            {getFieldDecorator('parentId', {
              initialValue: parentId
            })(
              <SelectCategoryTree tree={categoryTree} except={categoryId} noneText="NONE" />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              initialValue: name,
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Tax Group"
          >
            {getFieldDecorator('taxGroupId', {
              initialValue: taxGroupId
            })(
              <Select>
                <Option key="category-taxGroupId-null" value={null}>NONE</Option>
                {taxGroups.map(taxGroup =>
                  <Option key={taxGroup.taxGroupId} value={taxGroup.taxGroupId}>{taxGroup.name}</Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Category
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const UpdateCategoryPage = Form.create()(UpdateCategoryForm);

const mapStateToProps = state => ({
  category: state.category.category || {},
  categoryTree: state.category.categoryTree,
  salonId: state.salon.selectedSalonId,
  loading: state.category.categoriesLoading || state.category.updatingCategory,
  taxGroups: state.tax.taxGroups,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  updateCategory,
  getCategoryTree,
  getTaxGroups,
  getCategory,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UpdateCategoryPage);



// WEBPACK FOOTER //
// ./src/Category/UpdateCategoryPage.js